export default {
  'smsMessageTrace.title': 'Trazas Mensajes SMS',
};
